import CoordinateParser from 'coordinate-parser';

export function coordinateStringToLatLngObject(coordinates?: string): { lat: number; lng: number } {
  if (coordinates) {
    const coords = new CoordinateParser(coordinates);

    return { lat: coords.getLatitude(), lng: coords.getLongitude() };
  }

  return { lat: 0, lng: 0 };
}

function toDegreesMinutesAndSeconds(coordinate: number): string {
  const absolute = Math.abs(coordinate);
  const degrees = Math.floor(absolute);
  const minutesNotTruncated = (absolute - degrees) * 60;
  const minutes = Math.floor(minutesNotTruncated);
  const seconds = Math.floor((minutesNotTruncated - minutes) * 60);

  return `${degrees}°${minutes.toString().padStart(2, '0')}'${seconds.toString().padStart(2, '0')}`;
}

// `lat === 0` is a valid coordinate (the equator), so it must not be treated as "no value".
// Matches `apps/mobile/utils/coordinates.ts`, where this was already fixed.
export function formatLatitude(lat: number | null | undefined): string {
  if (lat || lat === 0) {
    return `${toDegreesMinutesAndSeconds(lat)}"${lat >= 0 ? 'N' : 'S'}`;
  }

  return '';
}

// `lng === 0` is a valid coordinate (the prime meridian) — see the note on `formatLatitude`.
export function formatLongitude(lng: number | null | undefined): string {
  if (lng || lng === 0) {
    return `${toDegreesMinutesAndSeconds(lng)}"${lng >= 0 ? 'E' : 'W'}`;
  }

  return '';
}
